/**
 * LanguageSelector component.
 */
import FlavourConfig from '@shared/config/flavours';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled language selector image.
 */
const LanguageSelector = styled.img`
  left: ${-32 * Screen.widthRatio}px;
  padding-top: ${7 * Screen.widthRatio}px;
  position: absolute;
  width: ${18 * Screen.widthRatio}px;
`;

/**
 * Default props for the language selector image.
 */
LanguageSelector.defaultProps = {
  src: FlavourConfig.images.menuSelector,
};

export default withImage(LanguageSelector, false);
